import {
  FileExcelOutlined,
  FilePdfOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Pagination,
  Popconfirm,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tooltip,
  message,
} from 'antd';
import dayjs from 'dayjs';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useEffect, useMemo, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Archiveicon } from '../../Images/Archiveicon.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import {
  archiveUser,
  createPassword,
  fetchUserList,
  fetchUserPermissionList,
  resetUserList,
  updateUserStatus,
} from '../../slices/user';

import { debounce } from 'lodash';
import PermissionsModal from './PermissionModal';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';
import { createActivityLog } from '../../slices/activity-log';
const { Option } = Select;
import logo from '../../Images/alux-logo.png';

export default function ManageUser() {
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [selectedUserId, setSelectedUserId] = useState(null);
  const { user: currentUser } = useSelector(state => state.auth);
  const { data = [], totalRecord } = useSelector(state => state.user);

  const handleRowClick = record => {
    navigate(`/view-user/${record.id}`);
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [debouncedSearch, setDebouncedSearch] = useState(null);
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(20);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [popVisible, setPopVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(
    localStorage.getItem('ManageUser') || '',
  );
  const [inputValue, setInputValue] = useState(
    localStorage.getItem('ManageUser') || '',
  );

  const ipAddress = useSelector(state => state.ip.ipAddress);
    useEffect(() => {
    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [ipAddress, dispatch]);

  const handleSubmit = values => {
    const payload = {
      user_id: selectedUserId, // Ensure selectedUserId is set correctly
      new_password: values.new_password,
      confirm_password: values.confirm_password,
    };

    setLoading(true); // Start loading spinner

    dispatch(createPassword({ values: payload }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Password Change Successfully!');
          handleCloseModal(); // Close the modal
        }
      })
      .catch(error => {
        console.error('Error:', error);
        if (error && typeof error === 'object') {
          const messages = Object.entries(error)
            .map(([key, value]) => `${key}: ${value.join(', ')}`)
            .join('; ');
          message.error(messages || 'An unknown error occurred.');
        } else {
          message.error(error?.message || 'An unknown error occurred.');
        }
      })
      .finally(() => {
        setLoading(false); // Stop loading spinner
      });
  };
  const handleOpenModal = record => {
    setIsModalVisible(true);
    setSelectedUserId(record.id);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedUserId(null);
  };

  const handleStatusChange = (value, record) => {
    setSelectedRecord(record);
    setSelectedValue(value);
    setPopVisible(true);
  };

  const confirmChange = () => {
    setPopVisible(false);
    const payload = {
      id: selectedRecord.id,
      status: selectedValue,
    };
    dispatch(updateUserStatus({ payload }))
      .unwrap()
      .then(result => {
        if (result) {
          message.success(result.message);
          setPage(1);
          dispatch(resetUserList());
          dispatch(
            fetchUserList({ page, pagesize, superuser: false, ...(search && { search: search }) }),
          );
        } else {
          message.error(result.message);
        }
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const cancelChange = () => {
    message.info('Status change canceled');
    setPopVisible(false);
  };

  useEffect(() => {
    dispatch(resetUserList());
    dispatch(fetchUserList({ page, pagesize, ...(search && { search: search }), ...({ superuser: false }) }));
  }, [page, pagesize, search]);

  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy(null);
    localStorage.removeItem('ManageUser');
    dispatch(fetchUserList({ page: 1, pagesize, superuser: false }));
  };

  const handlePageChange = newPage => {
    setPage(newPage);
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'username' && sortOrder === 'ascend') {
      sortingEnumKey = 'username';
    }
    if (sortField === 'username' && sortOrder === 'descend') {
      sortingEnumKey = '-username';
    }
    if (sortField === 'first_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'first_name';
    }
    if (sortField === 'first_name' && sortOrder === 'descend') {
      sortingEnumKey = '-first_name';
    }
    if (sortField === 'last_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'last_name';
    }
    if (sortField === 'last_name' && sortOrder === 'descend') {
      sortingEnumKey = '-last_name';
    }
    if (sortField === 'email' && sortOrder === 'ascend') {
      sortingEnumKey = 'email';
    }
    if (sortField === 'email' && sortOrder === 'descend') {
      sortingEnumKey = '-email';
    }
    if (sortField === 'status' && sortOrder === 'ascend') {
      sortingEnumKey = 'status';
    }
    if (sortField === 'status' && sortOrder === 'descend') {
      sortingEnumKey = '-status';
    }
    if (sortField === 'phone' && sortOrder === 'ascend') {
      sortingEnumKey = 'phone';
    }
    if (sortField === 'phone' && sortOrder === 'descend') {
      sortingEnumKey = '-phone';
    }
    return sortingEnumKey;
  };

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
  };
  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };

  const handleSearch = e => {
    const value = e.target.value;
    debouncedAPICall(value);
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('ManageUser', value);
  };
  const debouncedAPICall = useMemo(
    () =>
      debounce(query => {
        if (query.length >= 3) {
          dispatch(fetchUserList({ search: query, superuser: false }));
          localStorage.setItem('ManageUser', query);
        }
      }, 50),
    [],
  );
  useEffect(() => {
    return () => {
      debouncedAPICall.cancel();
    };
  }, [debouncedAPICall]);

  const handleEdit = data => {
    navigate(`/edit-user/${data.id}`);
  };
  const handleDelete = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }
    dispatch(archiveUser(id))
      .unwrap()
      .then(() => {
        message.success('User Archived Successfully!');
        dispatch(fetchUserList({ page, pagesize, search: debouncedSearch, superuser: false }));
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const [checkedList, setCheckedList] = useState([
    'username',
    'first_name',
    'last_name',
    'email',
    'phone',
    'status',
    'last_login',
    'id',
    'action',
  ]);

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      width: 50,
      render: (text, record, index) => (page - 1) * pagesize + index + 1,
    },
    {
      title: 'User Name',
      dataIndex: 'username',
      width: 100,
      key: 'username',
    },
    {
      title: 'First Name',
      dataIndex: 'first_name',
      key: 'first_name',

      width: 100,
    },
    {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',

      width: 100,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 150,
    },
    {
      title: 'Contact',
      dataIndex: 'phone',
      key: 'phone',
      width: 120,
      render: phone => {
        if (phone) {
          const cleanedPhone = String(phone).replace(/\D/g, '');

          if (cleanedPhone.startsWith('91')) {
            return `+91 ${cleanedPhone.slice(2, 7)} ${cleanedPhone.slice(7)}`;
          } else if (cleanedPhone.length > 5) {
            const countryCode = cleanedPhone.slice(0, cleanedPhone.length - 10);
            const localNumber = cleanedPhone.slice(-10);
            return `+${countryCode} ${localNumber.slice(
              0,
              5,
            )} ${localNumber.slice(5)}`;
          } else {
            return `+${cleanedPhone}`;
          }
        }
        return null;
      },
    },
    {
      title: 'Groups',
      dataIndex: 'groups',
      key: 'groups',
      width: 150,
      render: groups => (
        <>
          {groups?.map((group, index) => (
            <div key={index}>{group}</div>
          ))}
        </>
      ),
    },
    {
      title: 'Last Login',
      dataIndex: 'last_login',
      key: 'last_login',
      width: 80,
      render: record => {
        return (
          <span>
            {record !== null ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',

      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      render: record => {
        return (
          <span>
            {record ? `${record.first_name} ${record.last_name}` : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: record => {
        return (
          <span>
            {record && record.trim()
              ? dayjs(record).format('DD-MM-YYYY HH:mm')
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      render: record => {
        return (
          <span>
            {record && record.first_name?.trim() && record.last_name?.trim()
              ? `${record.first_name} ${record.last_name}`
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      fixed: 'right',
      width: 100,
      sorter: false,
      render: (status, record) => (
        <Popconfirm
          title={`Are you sure you want to change the status "${selectedValue}"?`}
          visible={popVisible && selectedRecord?.id === record.id}
          onConfirm={confirmChange}
          onCancel={cancelChange}
          okText="Yes"
          cancelText="No"
        >
          <div
            onClick={(e) => e.stopPropagation()} // ⛔ Prevents row click when interacting with Select
          >
            <Select
              value={status}
              style={{ width: 120 }}
              onChange={value => handleStatusChange(value, record)}
              placeholder="Select a status"
            >
              <Option value="active">Active</Option>
              <Option value="inactive">Inactive</Option>
              <Option value="pending">Pending</Option>
            </Select>
          </div>
        </Popconfirm>
      ),
    },
    // {
    //   title: 'Action',
    //   key: 'action',
    //   fixed: 'right',
    //   width: 90,
    //   render: (text, record) => (
    //     <>
    //       <Space>
    //         {currentUser.permissions.permissions.user.includes('view_user') && (
    //           <Tooltip placement="top" title={'View User Details'}>
    //             <Link to={`/view-user/${record.id}`}>
    //               <ViewIcon />
    //             </Link>
    //           </Tooltip>
    //         )}
    //         {currentUser.permissions.permissions.user.includes(
    //           'change_user',
    //         ) && (
    //           <Tooltip placement="top" title={'Edit'}>
    //             <span onClick={() => handleEdit(record)}>
    //               <EditIcon />
    //             </span>
    //           </Tooltip>
    //         )}

    //         <>
    //           <Tooltip placement="top" title={'Reset Password'}>
    //             <Popconfirm
    //               title="Are you sure you want to change the password?"
    //               onConfirm={() => handleOpenModal(record)} // Open the modal on confirmation
    //               onCancel={() => 'Canceled'}
    //               okText="Yes"
    //               cancelText="No"
    //             >
    //               <Passwordkey style={{fontSize: '20px', cursor: 'pointer'}} />
    //             </Popconfirm>
    //           </Tooltip>

    //           <Modal
    //             title={
    //               <div
    //                 style={{
    //                   color: '#123B66',
    //                   fontSize: '18px',
    //                   fontWeight: 'bold',
    //                   textAlign: 'center',
    //                 }}
    //               >
    //                 Change Password
    //               </div>
    //             }
    //             open={isModalVisible}
    //             onCancel={handleCloseModal}
    //             footer={[
    //               <Button
    //                 key="cancel"
    //                 onClick={handleCloseModal}
    //                 style={{
    //                   backgroundColor: '#f2f2f2',
    //                   border: 'none',
    //                   color: '#333',
    //                   fontWeight: 'bold',
    //                 }}
    //                 disabled={loading} // Disable while loading
    //               >
    //                 Cancel
    //               </Button>,
    //               <Button
    //                 key="save"
    //                 type="primary"
    //                 style={{
    //                   backgroundColor: '#123B66',
    //                   border: 'none',
    //                   fontWeight: 'bold',
    //                 }}
    //                 onClick={() => form.submit()}
    //               >
    //                 Save
    //               </Button>,
    //             ]}
    //             mask={false}
    //             style={{
    //               top: '20%',
    //             }}
    //           >
    //             <Spin spinning={loading}>
    //               <div>
    //                 <Form
    //                   onFinish={handleSubmit} // Handle form submission
    //                   form={form}
    //                   layout="vertical"
    //                   initialValues={{
    //                     new_password: '',
    //                     confirm_password: '',
    //                     user_id: selectedUserId, // Ensure selectedUserId is set correctly
    //                   }}
    //                 >
    //                   <Form.Item
    //                     name="new_password"
    //                     label={
    //                       <span
    //                         style={{
    //                           fontWeight: 'bold',
    //                           fontSize: '14px',
    //                           color: '#333',
    //                         }}
    //                       >
    //                         New Password:
    //                       </span>
    //                     }
    //                     rules={[
    //                       {
    //                         required: true,
    //                         message: 'Please enter a strong password',
    //                       },
    //                       {
    //                         pattern:
    //                           /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    //                         message:
    //                           'Password must be at least 8 characters long, with at least one uppercase letter, one lowercase letter, one number, and one special character.',
    //                       },
    //                     ]}
    //                   >
    //                     <Input.Password
    //                       placeholder="Please enter your password"
    //                       style={{
    //                         borderRadius: '5px',
    //                         height: '40px',
    //                         fontSize: '14px',
    //                       }}
    //                     />
    //                   </Form.Item>
    //                   <Form.Item
    //                     name="confirm_password"
    //                     label={
    //                       <span
    //                         style={{
    //                           fontWeight: 'bold',
    //                           fontSize: '14px',
    //                           color: '#333',
    //                         }}
    //                       >
    //                         Confirm Password:
    //                       </span>
    //                     }
    //                     dependencies={['new_password']}
    //                     rules={[
    //                       {
    //                         required: true,
    //                         message: 'Please confirm your password.',
    //                       },
    //                       ({getFieldValue}) => ({
    //                         validator(_, value) {
    //                           if (
    //                             !value ||
    //                             getFieldValue('new_password') === value
    //                           ) {
    //                             return Promise.resolve();
    //                           }
    //                           return Promise.reject(
    //                             new Error('Passwords do not match.'),
    //                           );
    //                         },
    //                       }),
    //                     ]}
    //                   >
    //                     <Input.Password
    //                       placeholder="Please confirm your password"
    //                       style={{
    //                         borderRadius: '5px',
    //                         height: '40px',
    //                         fontSize: '14px',
    //                       }}
    //                     />
    //                   </Form.Item>
    //                   <div style={{marginTop: '10px'}}>
    //                     <ul
    //                       style={{
    //                         listStyle: 'none',
    //                         padding: 0,
    //                         margin: 0,
    //                         fontSize: '14px',
    //                         color: '#666',
    //                       }}
    //                     >
    //                       <li>- Minimum 8 characters.</li>
    //                       <li>- At least one uppercase letter (A-Z).</li>
    //                       <li>- At least one lowercase letter (a-z).</li>
    //                       <li>- At least one digit (0-9).</li>
    //                       <li>- At least one special character (@$!%*?&).</li>
    //                     </ul>
    //                   </div>
    //                 </Form>
    //               </div>
    //             </Spin>
    //           </Modal>
    //         </>
    //         {currentUser.permissions.permissions.user.includes(
    //           'delete_user',
    //         ) && (
    //           <Tooltip placement="top" title={'Archive'}>
    //             <Popconfirm
    //               title="Are you sure you want to archive this record?"
    //               onConfirm={() => handleDelete(record.id)} // Correctly access `id`
    //               onCancel={() => message.info('Action cancelled')}
    //               okText="Yes"
    //               cancelText="No"
    //             >
    //               <Archive style={{cursor: 'pointer'}} />
    //             </Popconfirm>
    //           </Tooltip>
    //         )}

    //         {currentUser.permissions.permissions.user.includes('view_user') && (
    //           <Tooltip placement="top" title={'View Permissions'}>
    //             <InfoCircleOutlined
    //               onClick={() => {
    //                 setSelectedUser(record); // Store the entire record
    //                 setModalVisible(true);
    //               }}
    //             />
    //           </Tooltip>
    //         )}
    //       </Space>
    //     </>
    //   ),
    // },
  ];
  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="id" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="username">User Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="first_name">First Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="last_name">Last Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="email">Email</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="phone">Phone</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="status">Status</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="groups">Groups</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="last_login">Last Login</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="created_at">Created At</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="created_by">Created By</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="updated_at">Updated At</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="updated_by">Updated By</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const csvheaders = [
    { label: 'Sr. No', key: 'SrNo' },
    { label: 'First Name', key: 'first_name' },
    { label: 'Last Name', key: 'last_name' },
    { label: 'Email', key: 'email' },
    { label: 'Phone', key: 'phone' },
    { label: 'Status', key: 'status' },
    { label: 'Groups', key: 'groups' },
    { label: 'Last Login', key: 'last_login' },
    { label: 'difference', key: 'difference' },
    { label: 'created At', key: 'created_at' },
    { label: 'created By', key: 'created_by' },
    { label: 'Updated At', key: 'updated_at' },
    { label: 'Updated By', key: 'updated_by' },
  ];

  const csvFilterheaders = csvheaders.filter(column =>
    checkedList.includes(column.key),
  );

  const csvData = data.map((item, index) => ({
    SrNo: index + 1,
    first_name: item.first_name,
    last_name: item.last_name,
    email: item.email,
    phone: item.phone,
    status: item.status,
    groups: item?.groups ? item?.groups.join(', ') : '',
    last_login: item.last_login,
    created_at: item.created_at || 'N/A',
    created_by: item.created_by
      ? `${item.created_by.first_name} ${item.created_by.last_name}`
      : 'N/A',
    updated_at: item.updated_at || 'N/A',
    updated_by: item.updated_by
      ? `${item.updated_by.first_name} ${item.updated_by.last_name}`
      : 'N/A',
  }));

  const handlePdfDownload = async () => {
    /* PDF Download */
    const pdf = new jsPDF('p', 'pt', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const pdfColumns = [
      { header: 'Sr. No', dataKey: 'SrNo' },
      { header: 'First Name', dataKey: 'first_name' },
      { header: 'Last Name', dataKey: 'last_name' },
      { header: 'Email', dataKey: 'email' },
      { header: 'Phone', dataKey: 'phone' },
      { header: 'Status', dataKey: 'status' },
      { header: 'Groups', dataKey: 'groups' },
      { header: 'Last Login', dataKey: 'last_login' },
      { header: 'difference', dataKey: 'difference' },
      { header: 'created At', dataKey: 'created_at' },
      { header: 'created By', dataKey: 'created_by' },
      { header: 'Updated At', dataKey: 'updated_at' },
      { header: 'Updated By', dataKey: 'updated_by' },
    ];

    const pdffilteredColumns = pdfColumns.filter(column =>
      checkedList.includes(column.dataKey),
    );

    const rows = data.map((item, index) => ({
      SrNo: index + 1,
      first_name: item.first_name,
      last_name: item.last_name,
      email: item.email,
      phone: item.phone,
      status: item.status,
      groups: item?.groups ? item?.groups.join(', ') : '',
      last_login: item.last_login,
      created_at: item.created_at || 'N/A',
      created_by: item.created_by
        ? `${item.created_by.first_name} ${item.created_by.last_name}`
        : 'N/A',
      updated_at: item.updated_at || 'N/A',
      updated_by: item.updated_by
        ? `${item.updated_by.first_name} ${item.updated_by.last_name}`
        : 'N/A',
    }));

    pdf.setFont('times', 'bold');
    pdf.setFontSize(16);
    const headingText = 'Users';
    const headingX = pageWidth / 2 - pdf.getTextWidth(headingText) / 2;
    pdf.text(headingText, headingX, 40);

    pdf.autoTable({
      columns: pdffilteredColumns,
      body: rows,
      startY: 65,
      theme: 'grid',
      styles: {
        font: 'times',
        halign: 'center',
        overflow: 'linebreak',
        cellPadding: 3.5,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
      },
      headStyles: {
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        fillColor: false,
      },
      rowStyles: {
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      tableLineColor: [0, 0, 0],
      rowPageBreak: 'avoid',
      didDrawPage: data => {
        const pageNumber = pdf.internal.getNumberOfPages();
        const str = `Page ${pageNumber}`;
        const dateStr = new Date().toLocaleString();
        pdf.setFontSize(10);
        pdf.text(dateStr, 40, pageHeight - 20);
        pdf.text(str, pageWidth - 60, pageHeight - 20);
        if (pageNumber === 1) {
          pdf.addImage(logo, 'PNG', pageWidth - 170, 10, 150, 32);
        }
      },
    });
    pdf.save(`users${+new Date()}`);
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Users',
        ip_address: ipAddress,
        discription: 'Users pdf download successfully!',
      }),
    );
  };
  const activityLog = async () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Users',
        ip_address: ipAddress,
        discription: 'Users excel download successfully!',
      }),
    );
  };
  return (
    <div className='mainwrap'>
      <div className="sticyaction">
        <Row
          className="pagenamerow mb-0"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h2 style={{ margin: 0 }}>Users</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/dashboard">Home</Link> },
                  { title: 'Users' },
                ]}
              />
            </div>
          </Col>
          <Col>
            <Space size="small">
              <Input
                placeholder="Search"
                className="searchbox"
                prefix={<SearchOutlined />}
                value={inputValue}
                style={{ width: 190 }}
                onChange={handleSearch}
              />
              <Tooltip placement="top" title="Reset Filter">
                <Button
                  type="primary"
                  disabled={!search && !orderBy}
                  className="iconlink"
                  onClick={resetFilter}
                >
                  <FilterIcon />
                </Button>
              </Tooltip>
              {currentUser.permissions.permissions.user.includes(
                'download_user_excel_copy',
              ) && (
                  <Tooltip placement="top" title={'Export Excel'}>
                    <Button
                      type="primary"
                      className="iconlink"
                      style={{ width: '10px' }}
                      onClick={activityLog}
                    >
                      <CSVLink
                        filename={'users.csv'}
                        className="iconlink"
                        style={{ width: '10px' }}
                        data={csvData}
                        headers={csvFilterheaders}
                      >
                        <FileExcelOutlined />
                      </CSVLink>
                    </Button>
                  </Tooltip>
                )}
              {currentUser.permissions.permissions.user.includes(
                'download_user_pdf_copy',
              ) && (
                  <Tooltip placement="top" title={'Export PDF'}>
                    <Button
                      type="primary"
                      className="iconlink"
                      onClick={handlePdfDownload}
                    >
                      <FilePdfOutlined />
                    </Button>
                  </Tooltip>
                )}
              {currentUser.permissions.permissions.user.includes(
                'add_user',
              ) && (
                  <Link to="/add-user">
                    <Tooltip placement="top" title={'Add User'}>
                      <Button type="primary" icon={<PlusOutlined />}>
                        Add User
                      </Button>
                    </Tooltip>
                  </Link>
                )}
              <Tooltip placement="top" title="Archive">
                <Link to="/archive-user" className="iconlink">
                  {' '}
                  <Archiveicon style={{ cursor: 'pointer' }} />
                </Link>
              </Tooltip>
              <Tooltip placement="topLeft" title="Column Filter Options">
                <Dropdown
                  overlay={columnMenu}
                  trigger={['click']}
                  placement="bottomRight"
                  visible={dropdownVisible}
                  onVisibleChange={setDropdownVisible}
                >
                  <Button
                    type="primary"
                    icon={<ColumnList />}
                    onClick={e => e.preventDefault()}
                  />
                </Dropdown>
              </Tooltip>
            </Space>
          </Col>
        </Row>
      </div>
      <div className='tablewrp'>
        <Table
          dataSource={data}
          rowKey="id"
          columns={filteredColumns}
          pagination={false}
          scroll={{ x: '600px' }}
          onChange={handleTableChange}
          onRow={record => ({
            onClick: () => handleRowClick(record),
            style: { cursor: 'pointer' },
          })}
        />
      </div>

      <Pagination
        current={page}
        pageSize={pagesize}
        total={totalRecord}
        showSizeChanger
        onShowSizeChange={handlePageSizeChange}
        pageSizeOptions={['20', '50', '100']}
        showTotal={total => `Total ${total} items`}
        onChange={handlePageChange}
        locale={{ items_per_page: 'Items / Page' }}
      />

      <PermissionsModal
        visible={modalVisible}
        onClose={() => {
          setModalVisible(false);
          setSelectedUser(null);
        }}
        userData={selectedUser}
        userId={selectedUser?.id}
      />
    </div>
  );
}
